import React from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import ARButtons from "./widget/ARFButtons";
import { MainContainer } from "../../../widget/common/ui/MainContainer";
import ARFContent from "./ARFContent";
import { ARFContextProvider } from "../../../provider/chats/chats/ARF/ARFContextProvider";

const ARFScreen = (props: { screenMobileView: boolean }) => {
  const type: number = ResponsiveDeviceType();

  const bodyContent: JSX.Element = (
    <div>
      <div className="bgcolor-primary">
        <div
          className={`h-100 bgcolor-white ${
            type === 3
              ? ""
              : "border-top-left-radius border-top-right-radius pt-4"
          }`}
        >
          <MainContainer>
            <ARFContent />
          </MainContainer>
        </div>
      </div>

      {type === 3 && <ARButtons />}
    </div>
  );

  return (
    <ARFContextProvider>
      {props.screenMobileView === true ? (
        <Scaffold
          appBarTitle={AppTranslation.text("form")}
          isModal={true}
          bottomNavigationButton={<ARButtons />}
        >
          {bodyContent}
        </Scaffold>
      ) : (
        bodyContent
      )}
    </ARFContextProvider>
  );
};

export default ARFScreen;
//export const routeName: string = "/arf-form";
